<script lang="ts">
    import {onMount} from "svelte";
    import {marked} from "marked";
    import HoverTipsView from "../../../../../component/common/Message/HoverTipsView.svelte";

    export let binary;
    export let maxHeightEm = null;

    $: style = (() => {
        const styleArray = [];

        if (maxHeightEm != null) {
            styleArray.push(`max-height: ${maxHeightEm}em`);
            styleArray.push(`overflow-y: scroll`);
        }

        const style = styleArray.join(';');
        return style;
    })();

    onMount(() => {
    });


</script>

<div class="binary-description-view" style={style}>
    {#if binary.description != null}
        { @html marked(binary.description) }
    {:else}
        <span class="empty">
            説明なし<HoverTipsView message="編集で設定するか、アップロードAPIにて、 description　を指定すると表示されます"/>
        </span>
    {/if}

</div>

<style lang="scss">
    .binary-description-view {
        margin: 1em;
        padding: 0.5em;
        background-color: rgba(255, 255, 255, 0.6);
        font-size: 0.75em;

        border-style: solid;
        border-width: 1px;
        border-color: rgba(0, 0, 0, 0.2);
        border-radius: 4px;

        position: relative;

        min-height: 300px;

        :global(a) {
            text-decoration: underline;
            font-size: 1.1em;

            &:hover {
                text-decoration: underline;
            }
        }

        .empty {
            opacity: 0.5;
            font-size: 0.75em;
            user-select: none;

            display: flex;
            align-items: center;
            gap: 0.5em;
        }

    }
</style>